// @flow
import type { TeamList, RawTeamListType } from 'types/TeamList';
import { nullTeamList } from 'types/TeamList';
import { mergeIntoDefault, convertToJsDate } from 'utils/objectUtils';

export function convertTeamsListFromApi(rawTeamList: RawTeamListType): TeamList {

  if (!rawTeamList) {
    return nullTeamList;
  }
  const {
    type_rugby,
    defaut_home,
    home,
    title,
    link,
    link_results,
    dernieres_rencontres,
    boutique,
    prochaine_rencontre,
    joueur_du_mois,
    news,
    news_cat,
    bloc_results_past,
    bloc_prochaine_rencontre,
  } = rawTeamList;

  return mergeIntoDefault(nullTeamList, {
    type_rugby,
    defaut_home,
    home,
    title: title.rendered,
    link,
    link_results: link_results,
    dernieres_rencontres,
    boutique: {
      nom: boutique.nom,
      link: boutique.link,
      featured_image: boutique.featured_image,
      srcset: (!boutique.featured_media || typeof boutique.featured_media === 'number') ? 
        null : boutique.featured_media.sizes,
      },
    prochaine_rencontre: {
      adversaire: prochaine_rencontre.adversaire,
      embleme_france: prochaine_rencontre.embleme_france,
      embleme_adversaire: prochaine_rencontre.embleme_adversaire,
      reception: prochaine_rencontre.reception,
      competition: prochaine_rencontre.competition,
      journee: prochaine_rencontre.journee,
      date_rencontre: prochaine_rencontre.date_rencontre ? 
        new Date(convertToJsDate(prochaine_rencontre.date_rencontre)) : 
        prochaine_rencontre.date_rencontre,
      lieu: prochaine_rencontre.lieu,
      link: prochaine_rencontre.link,
      billetterie: prochaine_rencontre.billetterie,
      background: prochaine_rencontre.background,
      featured_media: prochaine_rencontre.featured_media,
    },
    joueur_du_mois: {
      nom : joueur_du_mois.nom,
      link : joueur_du_mois.link,
      featured_image :joueur_du_mois.featured_image,
      srcset: (!joueur_du_mois.featured_media || typeof joueur_du_mois.featured_media === 'number') ? 
        null : joueur_du_mois.featured_media.sizes,
    },
    news,
    news_cat,
    bloc_results_past,
    bloc_prochaine_rencontre,
    defaultImgTeam: "data:image/png;base64,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" // eslint-disable-line max-len
  });
}
